/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ServiceDto,
} from '../models/index';
import {
    ServiceDtoFromJSON,
    ServiceDtoToJSON,
} from '../models/index';

export interface ApiServicesByShowShowIdBookerBookerIdGetRequest {
    showId: number;
    bookerId: string;
}

/**
 * 
 */
export class ServicesApi extends runtime.BaseAPI {

    /**
     */
    async apiServicesByShowShowIdBookerBookerIdGetRaw(requestParameters: ApiServicesByShowShowIdBookerBookerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ServiceDto>>> {
        if (requestParameters['showId'] == null) {
            throw new runtime.RequiredError(
                'showId',
                'Required parameter "showId" was null or undefined when calling apiServicesByShowShowIdBookerBookerIdGet().'
            );
        }

        if (requestParameters['bookerId'] == null) {
            throw new runtime.RequiredError(
                'bookerId',
                'Required parameter "bookerId" was null or undefined when calling apiServicesByShowShowIdBookerBookerIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Services/ByShow/{showId}/booker/{BookerId}`.replace(`{${"showId"}}`, encodeURIComponent(String(requestParameters['showId']))).replace(`{${"BookerId"}}`, encodeURIComponent(String(requestParameters['bookerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ServiceDtoFromJSON));
    }

    /**
     */
    async apiServicesByShowShowIdBookerBookerIdGet(requestParameters: ApiServicesByShowShowIdBookerBookerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ServiceDto>> {
        const response = await this.apiServicesByShowShowIdBookerBookerIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
